export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11807.1f52d78e.jpg";